export enum CustomIcons {
  FILTERS = "filters",
  LEGEND = "legend",
  LIST = "list",
  RADIUS = "radius",
  REFRESH = "refresh",
  DROPDOWN_UP = "dropdown_up",
  DROPDOWN_DOWN = "dropdown_down",
  RADIUS_ACTIVE = "radius_active",
  COMMENT = "comment",
}
